<template>
    <div class="dashboard" v-if="user">
        <sep name="L"></sep>

        <main-container>
            <account-teaser mode="dashboard" :user="user" />
        </main-container>

        <sep name="L"></sep>

        <main-container>
            <h2 id="favorites">
                <typo name="title-30-normal"> Mes conventions collectives </typo>
            </h2>
        </main-container>

        <sep name="L"></sep>

        <div class="background">
            <sep name="L"></sep>
            <main-container>
                <dashboard-conventions :user="user" />
            </main-container>
            <sep name="XL"></sep>
        </div>

        <div class="background-push" id="pushes" v-if="hasPush">
            <main-container>
                <v-container>
                    <dashboard-push-section :user="user"></dashboard-push-section>
                </v-container>
            </main-container>
        </div>

        <sep name="L"></sep>

        <main-container id="search">
            <search />
        </main-container>

        <scroll-top />
    </div>
</template>

<script>
import { isArray } from "lodash";
import AccountTeaser from "../account/AccountTeaser.vue";
import ScrollTop from "src/components/common/scrollTop/ScrollTop.vue";
import Search from "src/components/search/Search.vue";
import DashboardConventions from "./DashboardConventions.vue";
import DashboardPushSection from "./DashboardPushSection.vue";

export default {
    components: { Search, DashboardConventions, DashboardPushSection, AccountTeaser, ScrollTop },
    props: ["user"],
    computed: {
        hasPush() {
            return this.user && isArray(this.user.pushes) && this.user.pushes.length > 0;
        },
    },
};
</script>

<style lang="sass" scoped>
.background
    background: $color-background
.background-push
    background: lighten($color-pink, 13%)
</style>
